import { createAction, props } from '@ngrx/store';
import { union } from '@ngrx/store';


export const resetPremium = createAction(
  '[Premium] Reset Premium'
);

export const loadPremium = createAction(
  '[Premium] Load Premium',
  props<{ premiumRequest: any }>()
);

export const loadPremiumSuccessful = createAction(
  '[Premium] Load Premimum Successful',
  props<{ premium: any }>()
);

export const reloadPremiumSuccessful = createAction(
  '[Premium] Reload Premimum Successful'
);

/*export const loadPremiumFailed = createAction(
  '[Premium] Load Premimum Failed',
  props<{ error: any }>()
);*/

export const updatePremium = createAction(
  '[Premium] Update Premimum',
  props<{ changeRequest: any }>()
);

export const updatePremiumSuccessful = createAction(
  '[Premium] Update Premimum Successful',
  props<{ premium: any }>()
);

export const updatePremiumFailed = createAction(
  '[Premium] Update Premimum Failed',
  props<{ error: any }>()
);

export const updatePremiumWithAddOn = createAction(
  '[Premium] Update Premimum With AddOn',
  props<{ changeRequest: any }>()
);

export const updatePremiumWithAddOnSuccessful = createAction(
  '[Premium] Update Premimum With AddOn Successful',
  props<{ premium: any }>()
);

export const updatePremiumWithAddOnFailed = createAction(
  '[Premium] Update Premimum With AddOn Failed',
  props<{ error: any }>()
);

export const updateRequestPayload = createAction(
  '[Premium] Update RequestPayload',
  props<{ premium: any }>()
);

export const updatenUpdateCarDetailsStatus = createAction(
  '[Premium] Update Car Details Status',
  props<{ isUpdateCarDetails: boolean }>()
);

export const resetError = createAction(
  '[Premium] Reset Error'
);

const all = union({
  loadPremium,
  loadPremiumSuccessful,
  reloadPremiumSuccessful,
  resetPremium,
  updatePremium,
  updatePremiumSuccessful,
  updatePremiumFailed,
  updatePremiumWithAddOn,
  updatePremiumWithAddOnSuccessful,
  updatePremiumWithAddOnFailed,
  updateRequestPayload,
  updatenUpdateCarDetailsStatus,
  resetError
});

export type PremiumActionsUnion = typeof all;
